module.exports = __webpack_public_path__ + "img/logo.c08b55df.svg";